import React from "react";
import DialogueBox from "UIComponents/DialogueBox";

const DIALOGUE_INFO = {
  FEEDBACK: {
    title: ({ t, firstName }) => {
      return t("classRoom:give_feedback_title", {
        firstName,
      });
    },
    modalBody: ({ t }) => {
      return t("common:proceed_confirm");
    },
    confirmButtonText: t => t("common:give_feedback_text"),
    cancelButtonText: t => t("common:cancel"),
  },
  DISCARD: {
    title: ({ t }) => {
      return t("discard_changes");
    },
    modalBody: ({ t }) => {
      return t("classRoom:discard_feedback_warning_msg");
    },
    confirmButtonText: t => t("common:discard_exit"),
    cancelButtonText: t => t("common:cancel"),
  },
};

const styles = {
  modalBodyStyle: {
    marginTop: "0",
    padding: "8px 48px 48px 48px",
    flex: "0",
    alignItems: "center",
  },
  cancelButtonStyle: {
    flexBasis: "0%",
    marginRight: "0",
  },
  cancelButtonProps: {
    color: "transparent",
    type: "hollow",
    disableHover: true,
  },
  footerContainerStyle: {
    padding: "0px 40px 28px 48px",
  },
  headerStyles: {
    padding: "28px 48px 4px 48px",
    display: "flex",
    alignItems: "center",
  },
};

const DialogBox = ({
  dialogueBoxState,
  t,
  studentName,
  onClickButton1,
  onClickButton2,
  toggleDialogueBoxDisplay,
}) => {
  return (
    <DialogueBox
      modalTitle={DIALOGUE_INFO[dialogueBoxState].title({
        t,
        firstName: studentName,
      })}
      modalBody={DIALOGUE_INFO[dialogueBoxState].modalBody({ t })}
      button1={DIALOGUE_INFO[dialogueBoxState].cancelButtonText(t)}
      button2={DIALOGUE_INFO[dialogueBoxState].confirmButtonText(t)}
      onClickButton1={onClickButton1}
      toggleDialogueBoxDisplay={toggleDialogueBoxDisplay}
      onClickButton2={onClickButton2}
      button1Props={styles.cancelButtonProps}
      button1Styles={styles.cancelButtonStyle}
      modalBodyStyle={styles.modalBodyStyle}
      footerContainerStyle={styles.footerContainerStyle}
      headerStyles={styles.headerStyles}
      size={"auto"}
    />
  );
};

export default DialogBox;
